import React from "react";
import GenericErrorIcon from "src/layout/ErrorPages/GenericErrorIcon";
import { LINKS } from "@consts";
import ErrorPage from "./ErrorPage";

const GenericErrorPage = ({ height }) => {
  const pageLinks = [
    { url: window.location.pathname, text: "Reload" },
    { url: LINKS.HYRO_SUPPORT, text: "Contact support" }
  ];

  return (
    <ErrorPage
      code="Oops!"
      message="Something went wrong"
      explanation="This page isn't working"
      links={pageLinks}
      Icon={GenericErrorIcon}
      testId='generic-error-page'
      height={height}
    />
  );
};

export default GenericErrorPage;
